import React, { useRef } from 'react';
import { CustomLabel } from '../Input/CustomLabel';
import { useTranslation } from 'react-i18next';
import { InputGroup } from 'react-bootstrap';
import classNames from 'classnames';
import style from './CSVReader.module.scss'

interface CsvReaderInterface {
    updateEmails: (emails: string[]) => void
}

const CsvReader = ({ updateEmails }: CsvReaderInterface) => {
    const { t } = useTranslation()
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent<FileReader>) => {
                const text = e.target?.result as string;
                parseCSV(text);
            };
            reader.readAsText(file);
        }
    };

    const parseCSV = (text: string) => {
        const rows = text.split('\n');
        const emailList: string[] = [];

        rows.forEach((row) => {
            const columns = row.split(',');
            const email = columns[0].trim(); // Assuming emails are in the first column
            if (validateEmail(email)) {
                emailList.push(email);
            }
        });
        updateEmails(emailList)
    };

    const validateEmail = (email: string): boolean => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    return (
        <InputGroup className='mt-3 d-flex flex-column'>
            <CustomLabel show label={t('Or Upload CSV to Extract Emails') as string} />
            <input type="file" accept=".csv" onChange={handleFileUpload} className='d-none' />
            <button onClick={handleButtonClick} className={classNames(style.inputButton, 'text-white')}>{t('chose_file')}</button>

        </InputGroup>
    );
};

export default CsvReader;
